
function HorizontalDraggable(){

    let horizontalSlider = document.querySelector('.horizontal-slider-container');
    if( horizontalSlider ) {
        this.build();
        resizeCallbacks.push(this);
    }

}

HorizontalDraggable.prototype.build = function(){

    let that = this;
    this.position_obj = [];

    this.slides = $('.horizontal-slide');
    let imageLoaded = 0;
    this.slides.each(function(i){
        $('img', this).on('load', function () {
            imageLoaded++;
            that.position_obj[i] = $(this).offset().left;
            if( imageLoaded === that.slides.length ){
                that.scrollPercent();
            }
        }).attr("src", $('img', this).attr('src'));
    });

    this.draggable = Draggable.create(".horizontal-slider", {
        type: "scrollLeft",
        edgeResistance: 0.9,
        maxDuration: 1.2,
        minDuration: 1.2,
        lockAxis: true,
        throwProps: true,
        onThrowUpdate : function(){
            // let wrapper_left = this.x * (-1) + that.w_width;

            that.scrollPercent();

            // $(position_obj).each(function( i, val ) {
            //     obj_c = i + 1;
            //     if( val < wrapper_left) {
            //         $('.horizontal-slide').removeClass('active');
            //         $('#horizontal-slide_'+obj_c).addClass('active');
            //         gsap.to( '.horizontal-slider-progress-percent', {
            //             scaleX : obj_c / slides.length
            //         });
            //         $('.horizontal-slider-counter-current').html( obj_c );
            //     }
            // });

        },
        snap: function(e) {
            let w_width = $(".horizontal-slider-container").width();
            let span_window_w = w_width;
            return -Math.round(Math.round(e / (0.3 * span_window_w)) * (0.3 * span_window_w));
        },
        dragClickables: false
    });

    $(".horizontal-slider").lightGallery({
        selector : '.zoom-in',
        mode: 'lg-slide',
        download: false,
        autoplay: false,
        share: false,
        rotate: false,
        zoom: false,
        fullScreen: false,
        autoplayControls: false,
        thumbnail: false
    }).on('onAfterOpen.lg',function(event){
        const dragItems = document.querySelectorAll(".lg-item");
        dragItems.forEach(el => {
            el.addEventListener("mouseenter", mouseAnimation.dragMouseEnter.bind(mouseAnimation));
            el.addEventListener("mouseleave", mouseAnimation.handleMouseLeave.bind(mouseAnimation));
        });
        const backItems = document.querySelectorAll(".lg-prev");
        backItems.forEach(el => {
            el.addEventListener("mouseenter", mouseAnimation.backLgPrev.bind(mouseAnimation));
            el.addEventListener("mouseleave", mouseAnimation.handleMouseLeave.bind(mouseAnimation));
        });
        const nextItems = document.querySelectorAll(".lg-next");
        nextItems.forEach(el => {
            el.addEventListener("mouseenter", mouseAnimation.nextLgPrev.bind(mouseAnimation));
            el.addEventListener("mouseleave", mouseAnimation.handleMouseLeave.bind(mouseAnimation));
        });
        const closeItems = document.querySelectorAll(".lg-close");
        closeItems.forEach(el => {
            el.addEventListener("mouseenter", mouseAnimation.closeLg.bind(mouseAnimation));
            el.addEventListener("mouseleave", mouseAnimation.handleMouseLeave.bind(mouseAnimation));
        });
    });

};

HorizontalDraggable.prototype.scrollPercent = function(){

    let that = this;
    let w_width = $(".horizontal-slider-container").width();
    let wrapper_left = Draggable.get(".horizontal-slider").x * (-1) + w_width;

    $(that.position_obj).each(function( i, val ) {
        let obj_c = i + 1;
        if( val < wrapper_left) {
            $('.horizontal-slide').removeClass('active');
            $('#horizontal-slide_'+obj_c).addClass('active');
            gsap.to( '.horizontal-slider-progress-percent', {
                scaleX : obj_c / that.slides.length
            });
            $('.horizontal-slider-counter-current').html( obj_c );
        }
    });

}

HorizontalDraggable.prototype.resize = function(){
    let that = this;
    TweenLite.set(".horizontal-slider", { x:0 });
    that.scrollPercent();
}
